import {ChangeDetectionStrategy, Component, Input} from "@angular/core";

require('./activity-packed-indication.scss');
@Component({
  standalone: false,
  selector: 'app-activity-packed-indication',
  templateUrl: './activity-packed-indication.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActivityPackedIndicationComponent {

  @Input() isPacked: any;
  @Input() packages: any;
  @Input() stopType: any;

  constructor() {
  }

}
